import React, { useEffect, useState } from 'react';
import api, { getCsrfCookie } from "./services/api";
import { Link, useNavigate } from 'react-router-dom';
import ROUTES from "./route";
import { useUser } from "./components/State/UserContext";

function App() {
    const { setUser } = useUser();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('api_token')) {
            navigate(ROUTES.HOME);
        }
    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleLogin = async (event) => {
        event.preventDefault();
        try {
            await getCsrfCookie();
            const response = await api.post('/login', formData);
            setMessage(response.data.message);
            if (response.data.success) {
                setUser(response.data.user);
                localStorage.setItem('api_token', response.data.token);
                navigate(ROUTES.HOME);
            }
        } catch (error) {
            console.error("Login error:", error);
            setMessage('An error occurred. Please try again.');
        }
    };

    return (
        <div className="min-h-screen bg-warm-50 flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <Link to={ROUTES.DEFAULT} className="inline-flex items-center gap-2 font-serif text-2xl font-bold text-warm-800 hover:text-warm-600 transition-colors mb-4">
                        <span className="text-3xl">📚</span>
                        My Books Library
                    </Link>
                    <h1 className="font-serif text-3xl font-bold text-warm-800 mb-2">Welcome back</h1>
                    <p className="text-warm-400 text-sm">Sign in to your reading collection</p>
                </div>

                <div className="bg-white rounded-2xl shadow-lg border border-warm-200 p-8">
                    <form onSubmit={handleLogin} className="space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-warm-700 mb-1.5">Email</label>
                            <input
                                type="email"
                                name="email"
                                placeholder="you@example.com"
                                value={formData.email}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3 bg-warm-50 border border-warm-200 rounded-lg text-warm-800 placeholder-warm-300 focus:outline-none focus:ring-2 focus:ring-warm-400 focus:border-transparent transition"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-warm-700 mb-1.5">Password</label>
                            <input
                                type="password"
                                name="password"
                                placeholder="••••••••"
                                value={formData.password}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3 bg-warm-50 border border-warm-200 rounded-lg text-warm-800 placeholder-warm-300 focus:outline-none focus:ring-2 focus:ring-warm-400 focus:border-transparent transition"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-warm-600 hover:bg-warm-700 text-white font-semibold py-3 rounded-lg transition-colors duration-200"
                        >
                            Sign In
                        </button>
                    </form>

                    {message && (
                        <p className="mt-4 text-center text-sm text-red-500">{message}</p>
                    )}

                    <p className="mt-6 text-center text-sm text-warm-400">
                        Don't have an account?{' '}
                        <Link to={ROUTES.REGISTER} className="text-warm-600 hover:text-warm-800 font-medium transition-colors">
                            Create one
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default App;
